import React from 'react';
import { SvgIcon, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';
import TimelineIcon from '@mui/icons-material/Timeline';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import LineWeightIcon from '@mui/icons-material/LineWeight';

// Floor Exercise Icon
export const FloorIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 360 307.15">
    <path d="M138.24 196.61h42.21v11.81H150.8v16h26.67v11.8H150.8v26.38h-12.56v-65.99zM198.1 239.67l-15.6-22.22h14.4l8.28 12.54h.65l7.81-12.54h14.87l-16 22.22 16 23H214.2l-8.56-12.92H205l-8.28 12.92h-14.41l15.79-23zM179.35 162.79c-.64 0-1.28-.14-1.85-.43L45 97.61a4.22 4.22 0 01-1.95-5.63 4.204 4.204 0 012.8-2.25L178.9 56.94c.66-.16 1.34-.16 2 0l134.2 33.07c2.26.55 3.65 2.83 3.1 5.09a4.175 4.175 0 01-2.28 2.8l-134.75 64.47c-.57.28-1.19.42-1.82.42zM59.1 95.11l120.23 58.76L301.6 95.36l-121.74-30L59.1 95.11z" />
    <path d="M179.28 178.48c-.67 0-1.33-.16-1.93-.46L10.18 94.35a4.342 4.342 0 01-1.94-5.82 4.347 4.347 0 012.87-2.28l168-40c.66-.16 1.34-.16 2 0L349.77 86.2a4.34 4.34 0 013.21 5.23 4.35 4.35 0 01-2.29 2.88l-169.48 83.72c-.6.3-1.26.45-1.93.45zM24.73 91.93l154.57 77.36 156.74-77.43L180.1 54.93l-155.37 37z" />
  </SvgIcon>
);

// Vault Icon
export const VaultIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 360 343.21">
    <path d="M131.79 232.85h13.57l13.74 39.74 2.43 8.49h.73l2.61-8.49 14.33-39.74h13.57l-24.26 66H155.3l-23.51-66zM203.18 264.02h-8v-10.33h8v-13.83h12.17v13.83h11.16v10.33h-11.16v18.05c-.01 1.01.1 2.02.34 3 .19.88.62 1.69 1.25 2.33.94 1.04 2.31 1.6 3.71 1.52.85.03 1.7-.08 2.51-.33.63-.22 1.22-.51 1.78-.87l3.44 10.6c-1.47.69-3.02 1.2-4.61 1.52-1.79.35-3.61.53-5.44.51-2.1 1.03-4.21-.34-6.18-1.09a12.91 12.91 0 01-4.6-3c-2.91-2.82-4.36-6.82-4.37-12v-20.24zM289.19 203.65h-63.32v-8.64c-.06-7.71-6.29-13.94-14-14h-5.85v-62.66h18.58c9.83 0 17.85-7.85 18.06-17.68V49.82a4.29 4.29 0 00-4.26-4.32H122.77c-2.38.02-4.3 1.94-4.33 4.32v50.6c.04 9.94 8.12 17.96 18.06 17.93h21.1v61.91c-.02.26.02.52.13.76h-7c-7.73 0-14 6.27-14 14v8.64H71.66c-2.42 0-4.39 1.97-4.39 4.39s1.97 4.39 4.39 4.39h65.09v1.52a4.29 4.29 0 004.25 4.33h80.55c2.38-.03 4.3-1.95 4.32-4.33v-1.52h63.32c2.42 0 4.39-1.97 4.39-4.39s-1.97-4.39-4.39-4.39v-.01zM127.1 54.15h106.91v10.8l-106.91-.26V54.15zm9.41 55.56a9.444 9.444 0 01-9.41-9.28V73.47l106.92.12v27c-.1 5.11-4.3 9.19-9.41 9.15l-88.1-.03zm80.59 99.92h-71.7v-14.62a5.26 5.26 0 015.31-5.21h61.18a5.16 5.16 0 015.21 5.11V209.63z" />
  </SvgIcon>
);

// Uneven Bars Icon
export const BarsIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 360 396.15">
    <path d="M289.42 258.12h-6.61v-11.06a6.41 6.41 0 00-2-4.7V76.97a7.99 7.99 0 00-1-3.94c.21-.39.3-.83.25-1.27v-1c0-2.92-2.54-5.21-5.85-5.21h-188c-3.31 0-5.73 2.29-5.73 5.21v1c-.03.3.01.61.13.89a7.984 7.984 0 00-1.27 4.32V239.54a6.41 6.41 0 00-2 4.7v11.06H72a4.328 4.328 0 00-4.53 4.12 4.328 4.328 0 004.12 4.53c.14.01.28.01.42 0h217.42a4.328 4.328 0 004.12-4.53 4.353 4.353 0 00-4.13-4.12zM94.14 76.97H265.9v81.8H94.79c-.22-.02-.43-.02-.65 0v-81.8zM265.9 242.36a6.41 6.41 0 00-2 4.7v11.06H96.17v-11.06a6.41 6.41 0 00-2-4.7v-72.14H265.9v72.14zM151.72 352.28c-3.6.05-7.17-.59-10.53-1.89a21.595 21.595 0 01-8.05-5.47 25.27 25.27 0 01-5.14-8.69 34.42 34.42 0 01-1.86-11.6v-39.69h12.42v40.38c-.02 2.06.26 4.1.83 6.08.5 1.74 1.35 3.37 2.49 4.78 1.12 1.36 2.53 2.45 4.14 3.17 1.79.8 3.74 1.19 5.7 1.15 1.99.05 3.97-.35 5.8-1.15 1.6-.73 3.02-1.81 4.14-3.17a13.56 13.56 0 002.48-4.78c.57-1.98.85-4.02.83-6.08v-40.38h12.42v39.69c.04 3.83-.56 7.64-1.8 11.27a24.714 24.714 0 01-5.15 8.74 23.458 23.458 0 01-8.09 5.66 27.087 27.087 0 01-10.63 1.98zM187.69 284.94h12.05v19.78l-.73 6.44h.73c1.26-2.05 3.04-3.74 5.16-4.88 2.65-1.42 5.63-2.11 8.64-2 2.84-.01 5.66.6 8.24 1.79 2.6 1.2 4.94 2.9 6.9 5a23.51 23.51 0 014.74 7.59 27.685 27.685 0 010 19.32 23.79 23.79 0 01-4.74 7.59 22.17 22.17 0 01-6.9 5 19.62 19.62 0 01-8.24 1.79 17 17 0 01-8.64-2 13.7 13.7 0 01-5.16-4.88H199v5.43h-11.31v-65.97zm23.37 56.21c1.56 0 3.11-.31 4.55-.92 1.43-.6 2.73-1.48 3.82-2.58 1.14-1.15 2.05-2.51 2.67-4 1.35-3.43 1.35-7.24 0-10.67-.62-1.51-1.53-2.88-2.67-4.05-1.1-1.1-2.39-1.97-3.82-2.57a11.67 11.67 0 00-4.55-.92c-1.56-.01-3.1.29-4.55.87-1.43.58-2.73 1.44-3.82 2.53a12.526 12.526 0 00-2.67 4 15.067 15.067 0 000 10.86c.62 1.5 1.53 2.85 2.67 4 1.08 1.1 2.39 1.96 3.82 2.53 1.44.6 2.99.92 4.55.92z" />
  </SvgIcon>
);

// Balance Beam Icon
export const BeamIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 360 319">
    <path d="M128.32 207.68h25.76A23 23 0 01162 209a20.3 20.3 0 016.39 3.68 17.56 17.56 0 014.28 5.48 15.94 15.94 0 01-1 15.5 16.55 16.55 0 01-6.3 5.38v.74a17.8 17.8 0 018.14 5.75 15.14 15.14 0 013.09 9.7 16.5 16.5 0 01-1.71 7.59 17.46 17.46 0 01-4.64 5.75 21.33 21.33 0 01-6.86 3.68 26.65 26.65 0 01-8.41 1.29h-26.66zm24.84 26.86a9 9 0 006.67-2.34 7.63 7.63 0 002.34-5.57 7.53 7.53 0 00-2.3-5.52 8.59 8.59 0 00-6.35-2.3h-12.78v15.73zm1.38 27.6c3.12 0 5.52-.78 7.17-2.34a7.93 7.93 0 002.49-6 8.18 8.18 0 00-2.53-6.12c-1.69-1.62-4.19-2.44-7.5-2.44h-13.43v16.93zM184.71 207.68h12v19.78l-.71 6.44h.73a13.7 13.7 0 015.16-4.88 17 17 0 018.64-2 19.62 19.62 0 018.24 1.79 22.17 22.17 0 016.9 5 23.82 23.82 0 014.74 7.59 27.68 27.68 0 010 19.32 23.82 23.82 0 01-4.74 7.59 22.17 22.17 0 01-6.9 5 19.62 19.62 0 01-8.24 1.79 17 17 0 01-8.64-2 13.7 13.7 0 01-5.16-4.88H196v5.43h-11.29zm23.37 56.21a11.56 11.56 0 004.55-.92 11.83 11.83 0 003.82-2.58 12.38 12.38 0 002.67-4 14.62 14.62 0 000-10.68 12.38 12.38 0 00-2.67-4 11.83 11.83 0 00-3.82-2.58 11.56 11.56 0 00-4.55-.92 12.08 12.08 0 00-4.55.87 11.43 11.43 0 00-3.82 2.53 12.53 12.53 0 00-2.67 4.05 15.1 15.1 0 000 10.86 12.53 12.53 0 002.67 4.05 11.43 11.43 0 003.82 2.53 12.08 12.08 0 004.55.79z" />
    <path d="M186.5 187.24h-11.81a3.25 3.25 0 01-3.25-3.25V69.71a3.25 3.25 0 013.25-3.25h11.81a3.24 3.24 0 013.25 3.25V184a3.24 3.24 0 01-3.25 3.24z" />
    <path d="M185.62 73h-10.05a9.7 9.7 0 01-9.68-9.69V49.67a5.19 5.19 0 015.18-5.19h19.05a5.2 5.2 0 015.19 5.19v13.62a9.7 9.7 0 01-9.69 9.71zm-13.23-22v12.29a3.19 3.19 0 003.18 3.19h10.05a3.19 3.19 0 003.19-3.19V51zM288.7 189.65H71.8a4.49 4.49 0 010-9h216.9a4.49 4.49 0 010 9zm0-2.47z" />
  </SvgIcon>
);

// Pommel Horse Icon
export const PommelHorseIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 360 330.45">
    <path d="M289.19 198.66H246.1v-33.57c-.02-3.32-1.69-6.42-4.45-8.26v-44.87h8.26a25.66 25.66 0 0017.93-7.38c4.7-4.68 7.36-11.04 7.37-17.67V73.05c.02-3.14-2.52-5.7-5.66-5.72h-52.99V51.57c0-2.42.8-7.89-7.6-8.14h-1c-8.52.25-7.81 5.72-7.81 8.14v15.76h-36.17V51.57c0-2.42.36-7.89-8.16-8.14h-1c-8.39.25-7.84 5.72-7.84 8.14v15.76h-55.6c-3.12.04-5.62 2.6-5.59 5.72v13.86a24.488 24.488 0 007.31 17.67 25.092 25.092 0 0017.8 7.38h8.52v45.25a9.436 9.436 0 00-4.07 7.88v33.57H71.66c-2.39 0-4.32 1.93-4.32 4.32s1.93 4.32 4.32 4.32h217.53c2.39 0 4.32-1.93 4.32-4.32s-1.93-4.32-4.32-4.32z m-178.25-95.48c-4.4.07-8.63-1.68-11.7-4.83a15.713 15.713 0 01-4.83-11.44V76.1h172v10.81a16.07 16.07 0 01-4.7 11.44c-3.14 3.13-7.4 4.87-11.83 4.83H110.94zm114.52 53.9a9.775 9.775 0 00-4.19 8v33.58h-81v-33.57c0-3.36-1.73-6.48-4.58-8.26v-44.87h89.8l-.03 45.12zM132.71 286.83v-66h23.39c3.03-.03 6.03.49 8.88 1.52 2.66.95 5.1 2.41 7.2 4.29 4.27 3.81 6.67 9.28 6.6 15 .1 5.76-2.31 11.29-6.6 15.13-2.1 1.88-4.55 3.34-7.2 4.29a25.596 25.596 0 01-8.88 1.52h-10.84v24.25h-12.55zm23.61-36.07c3.29 0 5.76-.93 7.44-2.77 1.62-1.72 2.52-4 2.51-6.37 0-1.16-.2-2.31-.61-3.4a7.721 7.721 0 00-1.86-2.91 9.221 9.221 0 00-3.11-2c-1.4-.52-2.88-.76-4.37-.73h-11.06v18.18h11.06zM186.71 220.81h12.18v18.53l-.75 8.21h.75a15.05 15.05 0 015.62-5.3c2.51-1.4 5.35-2.12 8.23-2.08 5.89 0 10.24 1.72 13.07 5.16 2.83 3.44 4.23 8.14 4.22 14.11v27.39h-12.17v-25.91c0-3.13-.75-5.52-2.24-7.14a8.013 8.013 0 00-6.23-2.45c-1.55-.03-3.09.34-4.46 1.06-1.3.71-2.43 1.71-3.3 2.91-.91 1.3-1.58 2.75-2 4.28-.47 1.7-.7 3.45-.69 5.21v22h-12.23v-65.98z" />
  </SvgIcon>
);

// Still Rings Icon
export const RingsIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 360 376.55">
    <path d="M159.63 195.74V73.56a9.933 9.933 0 00-1.27-4.7v-3.94a4.29 4.29 0 00-4.25-4.33h-.45V44.7c.02-1.03-.81-1.88-1.84-1.9h-.07c-1.03.05-1.85.87-1.9 1.9v15.89h-.26a4.29 4.29 0 00-4.32 4.26v4.01a10.05 10.05 0 00-1.27 4.7v122.18c-13.63 4.32-21.17 18.86-16.86 32.49s18.86 21.17 32.49 16.86 21.17-18.86 16.86-32.49a25.885 25.885 0 00-16.86-16.86zm-7.88 41.58c-9.39.16-17.13-7.32-17.29-16.7a17.019 17.019 0 0112.21-16.61c.41.15.84.24 1.27.25h7.75c.48-.01.95-.1 1.4-.25h.13c8.97 2.9 13.89 12.53 10.99 21.5a17.083 17.083 0 01-16.46 11.81zM216.97 195.87V73.56c.03-1.54-.41-3.04-1.27-4.32v-4.32a4.29 4.29 0 00-4.25-4.33H211V44.7c0-1.05-.86-1.91-1.91-1.91s-1.91.86-1.91 1.91v15.89h-.38a4.29 4.29 0 00-4.32 4.26V69.24a7.463 7.463 0 00-1.27 4.32v122.18c-13.51 4.45-20.86 19.01-16.41 32.53 4.45 13.51 19.01 20.86 32.53 16.41a25.753 25.753 0 0017.7-24.39c-.04-11.22-7.35-21.11-18.06-24.42zm-7.87 41.45c-9.39.24-17.19-7.17-17.43-16.56-.2-7.71 4.82-14.58 12.22-16.75.45.14.92.23 1.4.25h7.63a7.2 7.2 0 001.52-.25h.13c8.97 2.9 13.89 12.53 10.99 21.5a17.083 17.083 0 01-16.46 11.81zM161.85 332.04c-2.77.01-5.53-.4-8.18-1.2-2.57-.79-4.99-2-7.16-3.6-2.2-1.63-4.11-3.6-5.67-5.85-1.69-2.4-7-2.97-5.2-3.81-8.07l11.8-4.62c.75 3.11 2.33 5.96 4.56 8.26 2.28 2.22 5.38 3.41 8.56 3.27 1.27 0 2.53-.17 3.76-.5 1.16-.31 2.25-.81 3.25-1.48.94-.63 1.72-1.47 2.28-2.45.58-1.04.87-2.21.84-3.4.02-1.14-.21-2.27-.66-3.32a7.658 7.658 0 00-2.18-2.77c-1.23-.99-2.57-1.83-4-2.49a60.75 60.75 0 00-6.09-2.49l-4.05-1.52c-1.89-.65-3.71-1.49-5.44-2.49-1.83-1.03-3.51-2.3-5-3.78a18.829 18.829 0 01-3.67-5.21c-.99-2.12-1.48-4.44-1.44-6.78-.02-2.5.5-4.97 1.53-7.24 1.03-2.25 2.53-4.26 4.38-5.9a20.4 20.4 0 016.78-4 28.221 28.221 0 0117.48-.09c2.25.78 4.35 1.93 6.22 3.41 1.62 1.29 3.01 2.83 4.14 4.56.96 1.47 1.74 3.05 2.33 4.7l-11.06 4.62a11.79 11.79 0 00-3.4-5 9.714 9.714 0 00-6.74-2.22c-2.4-.09-4.77.57-6.78 1.89a5.77 5.77 0 00-2.7 4.94c.02 1.99.98 3.85 2.6 5a28.02 28.02 0 008.27 4l4.19 1.39c2.51.86 4.95 1.92 7.29 3.18a22.57 22.57 0 015.67 4.28c1.57 1.64 2.8 3.57 3.63 5.68.88 2.34 1.3 4.83 1.25 7.33.08 3.1-.63 6.16-2.08 8.9-1.33 2.4-3.15 4.49-5.35 6.13a23.508 23.508 0 01-7.35 3.6c-2.59.82-5.28 1.27-8 1.33zM193.45 285.37h11.44v6.27h.74c.58-1.11 1.34-2.13 2.24-3 .94-1.98-1.73 3.11-2.41 1.17-.69 2.41-1.24 3.71-1.65 1.29-.42 2.64-.64 4-.64 1.4-.03 2.8.14 4.15.51 1.04.29 2.02.75 2.92 1.34l-3.26 10.79a10.7 10.7 0 00-2.45-.88c-1.09-.24-2.2-.34-3.31-.32-1.57-.01-3.13.33-4.55 1-1.35.64-2.54 1.57-3.49 2.73a13.03 13.03 0 00-2.23 4.13c-.54 1.66-.81 3.4-.79 5.14v22.25h-12.23v-45.26z" />
  </SvgIcon>
);

// Parallel Bars Icon
export const ParallelBarsIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 360 378.23">
    <path d="M131.5 334.55v-66h23.43c3.03-.02 6.03.49 8.88 1.52 2.65.96 5.1 2.41 7.2 4.29 2.05 1.85 3.7 4.09 4.85 6.6a21.295 21.295 0 010 17c-1.15 2.51-2.8 4.75-4.85 6.6-2.1 1.88-4.55 3.33-7.2 4.29a25.596 25.596 0 01-8.88 1.52H144.1v24.25l-12.6-.07zm23.6-36.05c3.28 0 5.76-.93 7.43-2.77 1.64-1.71 2.56-4 2.57-6.37 0-1.16-.2-2.31-.6-3.4a7.721 7.721 0 00-1.86-2.91 9.221 9.221 0 00-3.11-2c-1.4-.52-2.88-.76-4.37-.73H144.1v18.17l11.01zM185.52 268.52h12.18v19.83l-.75 6.46h.75c1.27-2.06 3.07-3.75 5.2-4.89 2.69-1.42 5.7-2.11 8.74-2 2.87-.01 5.71.6 8.32 1.8 2.63 1.2 5.01 2.9 7 5 2.06 2.21 3.69 4.8 4.78 7.62a27.355 27.355 0 010 19.36c-1.09 2.82-2.71 5.4-4.78 7.61-1.99 2.1-4.37 3.8-7 5-2.61 1.2-5.45 1.81-8.32 1.8-3.04.11-6.05-.58-8.74-2a13.722 13.722 0 01-5.2-4.89h-.75v5.44h-11.43v-66.14zm23.58 56.35c1.58 0 3.15-.31 4.61-.92a12.26 12.26 0 003.85-2.59c1.16-1.16 2.07-2.54 2.7-4.05a14.54 14.54 0 000-10.7 12.76 12.76 0 00-2.7-4.06c-1.11-1.1-2.41-1.98-3.85-2.58-1.46-.61-3.03-.92-4.61-.92-1.57-.01-3.14.29-4.6.87a11.53 11.53 0 00-3.85 2.54 12.332 12.332 0 00-2.7 4.06c-1.37 3.5-1.37 7.38 0 10.88.62 1.52 1.54 2.9 2.7 4.06 1.1 1.1 2.41 1.96 3.85 2.53 1.46.58 3.02.88 4.6.88zM293.51 247.32a4.29 4.29 0 01-4.26 4.32H71.66c-2.39 0-4.32-1.93-4.32-4.32s1.93-4.32 4.32-4.32h65l-1.18-107.34a8.792 8.792 0 015.34-8.13l.25-53a52.43 52.43 0 012.16-9l.64-2.16c.13-.32.2 1-.66.25-1-1.5-2.11-2.3-4.65-2.28-7.24 0-6.36 4.45-11.45 9.91-11.45s9.92 5.09 9.92 11.45c.07 3.72-1.62 7.26-4.57 9.53-.12.26-.12.64-.25.89l-.76 2.67c-.81 2.41-1.44 4.88-1.91 7.38l-.13 2.79v48.82a8.845 8.845 0 016.61 8.52l1.15 107.31h37.29l1.09-107.38a8.84 8.84 0 016.74-8.52l-.25-51.87c-.39-2.29-1.28-5.08-1.91-7.37l-.76-2.16c-.13-.38-.13-.77-.26-1.15a12.007 12.007 0 01-4.45-9.53c0-6.36 4.45-11.45 9.92-11.45s9.92 5.09 9.92 11.45c.02 2.65-.83 5.24-2.42 7.37.13.13.13.38.25.64l.77 2.54c.9 2.84 1.62 5.72 2.16 8.65l.25 3.3v50.1a8.858 8.858 0 015.22 8l-1.15 107.31h65c2.36-.01 4.28 1.91 4.29 4.27Z" />
  </SvgIcon>
);

// High Bar Icon
export const HighBarIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 360 396.15">
    <path d="M289.19 258.93h-6.61v-11.06a6.41 6.41 0 00-2-4.7V55.77c.02-1.38-.33-2.74-1-3.94.21-.39.3-.84.25-1.28v-1c0-2.93-2.54-5.22-5.85-5.22h-188c-3.31 0-5.73 2.29-5.73 5.22v1c-.03.3.01.61.13.89a7.909 7.909 0 00-1.27 4.33V240.8a6.41 6.41 0 00-2 4.7v11.06h-5.34a4.328 4.328 0 00-4.53 4.12 4.328 4.328 0 004.12 4.53c.14.01.28.01.42 0H289.2a4.328 4.328 0 004.12-4.53 4.353 4.353 0 00-4.13-4.12zm-23.52-15.76a6.41 6.41 0 00-2 4.7v11.06H95.94v-11.06a6.41 6.41 0 00-2-4.7V55.77h171.73v187.4zM126.01 285.74h12.55v26.38h28v-26.38h12.54v66h-12.56v-27.82h-28v27.85h-12.53v-66.03zM190.98 285.74h12.18v19.88l-.75 6.46h.75c1.28-2.06 3.07-3.74 5.2-4.9 2.69-1.41 5.7-2.1 8.74-2 2.87-.01 5.71.6 8.32 1.79 2.63 1.2 5.01 2.9 7 5 2.06 2.21 3.69 4.79 4.78 7.61a27.382 27.382 0 010 19.37c-1.09 2.82-2.72 5.4-4.78 7.61-1.99 2.1-4.36 3.8-7 5-2.61 1.19-5.45 1.8-8.32 1.8-3.04.11-6.05-.58-8.74-2a13.952 13.952 0 01-5.2-4.89h-.75v5.44h-11.43v-66.17zm23.61 56.34c1.58.01 3.15-.3 4.61-.91 1.45-.59 2.78-1.46 3.9-2.55 1.16-1.16 2.08-2.54 2.71-4.06 1.35-3.43 1.35-7.24 0-10.67-.6 3-1.52-1.55-2.89-2.71-4.06-1.11-1.1-2.41-1.98-3.85-2.58-1.46-.61-3.03-.93-4.61-.92-1.57-.01-3.14.29-4.6.87a11.53 11.53 0 00-3.85 2.54 12.525 12.525 0 00-2.69 4.05 14.74 14.74 0 000 10.89c.62 1.52 1.53 2.9 2.69 4.06 1.1 1.09 2.41 1.95 3.85 2.53 1.45.56 2.99.84 4.55.83z" />
  </SvgIcon>
);

// Simplified Icon Variants - More consistent and cleaner
export const SimpleFXIcon = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <FitnessCenterIcon {...props} sx={{ fontSize: 24, color: 'white' }} />
    </Box>
  );
};

export const SimpleVTIcon = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <ChangeHistoryIcon {...props} sx={{ fontSize: 24, color: 'white' }} />
    </Box>
  );
};

export const SimpleUBIcon = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <ViewInArIcon {...props} sx={{ fontSize: 24, color: 'white' }} />
    </Box>
  );
};

export const SimpleBBIcon = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <HorizontalRuleIcon {...props} sx={{ fontSize: 24, color: 'white' }} />
    </Box>
  );
};

export const SimplePHIcon = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <SportsGymnasticsIcon {...props} sx={{ fontSize: 24, color: 'white' }} />
    </Box>
  );
};

export const SimpleSRIcon = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <TimelineIcon {...props} sx={{ fontSize: 24, color: 'white' }} />
    </Box>
  );
};

export const SimplePBIcon = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <LineWeightIcon {...props} sx={{ fontSize: 24, color: 'white' }} />
    </Box>
  );
};

export const SimpleHBIcon = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <CropSquareIcon {...props} sx={{ fontSize: 24, color: 'white' }} />
    </Box>
  );
};

// Generic apparatus icon using the provided path
export const ApparatusIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M4.62 11.79a9.714 9.714 0 00-3.4-5 9.714 9.714 0 013.4-5 9.714 9.714 0 019.76 0 9.714 9.714 0 013.4 5 9.714 9.714 0 00-3.4 5 9.714 9.714 0 01-9.76 0z"/>
  </SvgIcon>
);

// Map apparatus abbreviations to icons - Detailed SVG versions
export const getApparatusIcon = (apparatusAbbrev, competitionColors) => {
  const iconMap = {
    'FX': (props) => <FXnoText {...props} competitionColors={competitionColors} />,
    'VT': (props) => <VTnoText {...props} competitionColors={competitionColors} />,
    'UB': (props) => <UBnoText {...props} competitionColors={competitionColors} />,
    'BB': (props) => <BBnoText {...props} competitionColors={competitionColors} />,
    'PH': (props) => <PHnoText {...props} competitionColors={competitionColors} />,
    'SR': (props) => <SRnoText {...props} competitionColors={competitionColors} />,
    'PB': (props) => <PBnoText {...props} competitionColors={competitionColors} />,
    'HB': (props) => <HBnoText {...props} competitionColors={competitionColors} />,
  };

  return iconMap[apparatusAbbrev] || ApparatusIcon;
};

// Simplified icon versions - cleaner and more consistent
export const getSimpleApparatusIcon = (apparatusAbbrev, competitionColors) => {
  const iconMap = {
    'FX': (props) => <SimpleFXIcon {...props} competitionColors={competitionColors} />,
    'VT': (props) => <SimpleVTIcon {...props} competitionColors={competitionColors} />,
    'UB': (props) => <SimpleUBIcon {...props} competitionColors={competitionColors} />,
    'BB': (props) => <SimpleBBIcon {...props} competitionColors={competitionColors} />,
    'PH': (props) => <SimplePHIcon {...props} competitionColors={competitionColors} />,
    'SR': (props) => <SimpleSRIcon {...props} competitionColors={competitionColors} />,
    'PB': (props) => <SimplePBIcon {...props} competitionColors={competitionColors} />,
    'HB': (props) => <SimpleHBIcon {...props} competitionColors={competitionColors} />,
  };

  return iconMap[apparatusAbbrev] || ApparatusIcon;
};

// No Text Variants
export const FXnoText = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <SvgIcon {...props} viewBox="0 0 348.25 227.75" xmlSpace="preserve" fill="white" sx={{ fontSize: 24 }}>
        <path d="M178.29,215.5a4.21,4.21,0,0,1-1.85-.42L43.94,150.33a4.21,4.21,0,0,1,.85-7.88l133.05-32.79a4.23,4.23,0,0,1,2,0L314,142.72a4.21,4.21,0,0,1,.82,7.89L180.11,215.08A4.12,4.12,0,0,1,178.29,215.5ZM58,147.83l120.23,58.75,122.27-58.5-121.74-30Z" transform="translate(-5.26 -49.47)" />
        <path d="M178.22,231.19a4.32,4.32,0,0,1-1.93-.46L9.12,147.07a4.34,4.34,0,0,1,.93-8.1l168-40a4.23,4.23,0,0,1,2,0L349.77,139.07a4.34,4.34,0,0,1,.92,8.11L180.15,230.75A4.3,4.3,0,0,1,178.22,231.19ZM23.67,144.65,178.24,222,335,144.58,179,107.65Z" transform="translate(-5.26 -49.47)" />
      </SvgIcon>
    </Box>
  );
};

export const HBnoText = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <SvgIcon {...props} viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="white" sx={{ fontSize: 24 }}>
        <path d="M282.73,256.56h-6.61V245.5a6.41,6.41,0,0,0-2-4.7V53.4a7.86,7.86,0,0,0-1-3.94,2.19,2.19,0,0,0,.25-1.28v-1c0-2.93-2.54-5.22-5.85-5.22h-188c-3.31,0-5.73,2.29-5.73,5.22v1a1.81,1.81,0,0,0,.13.89,7.91,7.91,0,0,0-1.27,4.33V240.8a6.41,6.41,0,0,0-2,4.7v11.06H65.31a4.33,4.33,0,0,0-.41,8.65,2.94,2.94,0,0,0,.42,0H282.74a4.33,4.33,0,0,0,0-8.65ZM259.21,240.8a6.41,6.41,0,0,0-2,4.7v11.06H89.48V245.5a6.41,6.41,0,0,0-2-4.7V53.4H259.21V240.8Z" transform="translate(-59.95 -39.72)" />
      </SvgIcon>
    </Box>
  );
};

export const PBnoText = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <SvgIcon {...props} viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="white" sx={{ fontSize: 24 }}>
        <path d="M289.74,248.36a4.29,4.29,0,0,1-4.26,4.32H67.89a4.32,4.32,0,1,1,0-8.64h65L131.71,136.7a8.79,8.79,0,0,1,5.34-8.13l.25-53a52.43,52.43,0,0,1,2.16-9l.64-2.16a3.86,3.86,0,0,0,.25-1,12.35,12.35,0,0,1-2.28-7.24c0-6.36,4.45-11.45,9.91-11.45s9.92,5.09,9.92,11.45a11.74,11.74,0,0,1-4.57,9.53c-.12.26-.12.64-.25.89l-.76,2.67a55.14,55.14,0,0,0-1.91,7.38l-.13,2.79v48.82a8.85,8.85,0,0,1,6.61,8.52L158,244.08h37.29l1.09-107.38a8.84,8.84,0,0,1,6.74-8.52l-.25-51.87c-.39-2.29-1.28-5.08-1.91-7.37l-.76-2.16c-.13-.38-.13-.77-.26-1.15a12,12,0,0,1-4.45-9.53c0-6.36,4.45-11.45,9.92-11.45s9.92,5.09,9.92,11.45A12.17,12.17,0,0,1,213,63.47c.13.13.13.38.25.64l.77,2.54a71.47,71.47,0,0,1,2.16,8.65l.25,3.3v50.1a8.86,8.86,0,0,1,5.22,8L220.45,244h65a4.28,4.28,0,0,1,4.29,4.27Z" transform="translate(-62.78 -34.79)" />
      </SvgIcon>
    </Box>
  );
};

export const PHnoText = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <SvgIcon {...props} viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="white" sx={{ fontSize: 24 }}>
        <path d="M276.91,215.48H233.82V181.91a10,10,0,0,0-4.45-8.26V128.78h8.26a25.66,25.66,0,0,0,17.93-7.38,25,25,0,0,0,7.37-17.67V89.87a5.69,5.69,0,0,0-5.66-5.72h-53V68.39c0-2.42.8-7.89-7.6-8.14h-1c-8.52.25-7.81,5.72-7.81,8.14V84.15H151.7V68.39c0-2.42.36-7.89-8.16-8.14h-1c-8.39.25-7.84,5.72-7.84,8.14V84.15H79.1a5.67,5.67,0,0,0-5.59,5.72v13.86a24.49,24.49,0,0,0,7.31,17.67,25.09,25.09,0,0,0,17.8,7.38h8.52V174a9.44,9.44,0,0,0-4.07,7.88v33.57H59.38a4.32,4.32,0,1,0,0,8.64H276.91a4.32,4.32,0,0,0,0-8.64ZM98.66,120A16,16,0,0,1,87,115.17a15.71,15.71,0,0,1-4.83-11.44V92.92h172v10.81a16.07,16.07,0,0,1-4.7,11.44A16.54,16.54,0,0,1,237.6,120Zm114.52,53.9a9.78,9.78,0,0,0-4.19,8v33.58H128V181.91a9.74,9.74,0,0,0-4.58-8.26V128.78h89.8Z" transform="translate(-54.28 -28.31)" />
      </SvgIcon>
    </Box>
  );
};

export const SRnoText = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <SvgIcon {...props} viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="white" sx={{ fontSize: 24 }}>
        <path d="M159.07,212.88V90.7A9.93,9.93,0,0,0,157.8,86V82.06a4.29,4.29,0,0,0-4.25-4.33h-.45V61.84a1.87,1.87,0,0,0-1.84-1.9h-.07a2,2,0,0,0-1.9,1.9V77.73H149A4.29,4.29,0,0,0,144.71,82v4a10,10,0,0,0-1.27,4.7V212.88a25.88,25.88,0,1,0,15.63,0Zm-7.88,41.58a17,17,0,0,1-5.08-33.31,4,4,0,0,0,1.27.25h7.75a4.74,4.74,0,0,0,1.4-.25h.13a17.07,17.07,0,0,1-5.47,33.31Z" transform="translate(-66.04 -47.81)" />
        <path d="M216.41,213V90.7a7.46,7.46,0,0,0-1.27-4.32V82.06a4.29,4.29,0,0,0-4.25-4.33h-.45V61.84a1.91,1.91,0,0,0-3.82,0V77.73h-.38A4.29,4.29,0,0,0,201.92,82v4.39a7.46,7.46,0,0,0-1.27,4.32V212.88a26.15,26.15,0,1,0,15.76.13Zm-7.87,41.45a17,17,0,0,1-5.21-33.31,5.49,5.49,0,0,0,1.4.25h7.63a7.2,7.2,0,0,0,1.52-.25H214a17.07,17.07,0,0,1-5.47,33.31Z" transform="translate(-66.04 -47.81)" />
      </SvgIcon>
    </Box>
  );
};

export const UBnoText = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <SvgIcon {...props} viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="white" sx={{ fontSize: 24 }}>
        <path d="M288.63,255.3H282V244.24a6.45,6.45,0,0,0-2-4.7V74.15a8.07,8.07,0,0,0-1-3.94,2.16,2.16,0,0,0,.25-1.27v-1c0-2.92-2.54-5.21-5.85-5.21h-188c-3.31,0-5.73,2.29-5.73,5.21v1a1.81,1.81,0,0,0,.13.89,7.9,7.9,0,0,0-1.27,4.32V239.54a6.41,6.41,0,0,0-2,4.7V255.3H71.21a4.33,4.33,0,1,0-.42,8.65H288.63a4.33,4.33,0,0,0,0-8.65ZM93.35,74.15H265.11V156H94a3.53,3.53,0,0,0-.65,0ZM265.11,239.54a6.41,6.41,0,0,0-2,4.7V255.3H95.38V244.24a6.41,6.41,0,0,0-2-4.7V167.4H265.11Z" transform="translate(-65.84 -49.47)" />
      </SvgIcon>
    </Box>
  );
};

export const VTnoText = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <SvgIcon {...props} viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="white" sx={{ fontSize: 24 }}>
        <path d="M286.84,226.58H223.52v-8.64a14.11,14.11,0,0,0-14-14h-5.85V141.28h18.58a18.06,18.06,0,0,0,18.06-17.68V72.75a4.29,4.29,0,0,0-4.26-4.32H120.42a4.37,4.37,0,0,0-4.33,4.32v50.6a18,18,0,0,0,18.06,17.93h21.1v61.91a1.53,1.53,0,0,0,.13.76h-7a14,14,0,0,0-14,14h0v8.64H69.31a4.39,4.39,0,0,0,0,8.78H134.4v1.52a4.29,4.29,0,0,0,4.25,4.33H219.2a4.37,4.37,0,0,0,4.32-4.33v-1.52h63.32a4.39,4.39,0,1,0,0-8.78ZM124.75,77.08H231.66v10.8l-106.91-.26Zm9.41,55.56a9.44,9.44,0,0,1-9.41-9.28v-27l106.92.12v27a9.34,9.34,0,0,1-9.41,9.15Zm80.59,99.92h-71.7V217.94a5.26,5.26,0,0,1,5.31-5.21h61.18a5.16,5.16,0,0,1,5.21,5.11v14.72Z" transform="translate(-64.2 -40.95)" />
      </SvgIcon>
    </Box>
  );
};

export const BBnoText = ({ competitionColors, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: competitionColors?.primary || theme.palette.primary.main,
        borderRadius: 1,
      }}
    >
      <SvgIcon {...props} viewBox="0 0 227.75 227.75" xmlSpace="preserve" fill="white" sx={{ fontSize: 24 }}>
        <path d="M287.24,223.49h-99V114.89a9.7,9.7,0,0,0,5.55-8.75V92.51a5.19,5.19,0,0,0-5.18-5.18h-19a5.2,5.2,0,0,0-5.19,5.18v13.63a9.69,9.69,0,0,0,5.56,8.75v108.6H70.34a4.5,4.5,0,0,0,0,9h216.9a4.5,4.5,0,0,0,0-9ZM170.92,93.82h16.42v12.31a3.2,3.2,0,0,1-2.86,3.16l-.32,0h-10l-.33,0a3.19,3.19,0,0,1-2.86-3.16Z" transform="translate(-64.92 -46.04)" />
      </SvgIcon>
    </Box>
  );
};

const ApparatusIcons = {
  // Original detailed icons
  FloorIcon,
  VaultIcon,
  BarsIcon,
  BeamIcon,
  PommelHorseIcon,
  RingsIcon,
  ParallelBarsIcon,
  HighBarIcon,
  ApparatusIcon,
  getApparatusIcon,
  
  // No-text detailed variants
  FXnoText,
  PHnoText,
  SRnoText,
  VTnoText,
  PBnoText,
  HBnoText,
  UBnoText,
  BBnoText,
  
  // Simplified clean variants
  SimpleFXIcon,
  SimpleVTIcon,
  SimpleUBIcon,
  SimpleBBIcon,
  SimplePHIcon,
  SimpleSRIcon,
  SimplePBIcon,
  SimpleHBIcon,
  getSimpleApparatusIcon,
};

export default ApparatusIcons;